/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { LeagueResponse } from './LeagueResponse';
import {
    LeagueResponseFromJSON,
    LeagueResponseFromJSONTyped,
    LeagueResponseToJSON,
    LeagueResponseToJSONTyped,
} from './LeagueResponse';

/**
 * 
 * @export
 * @interface GetLeaguesResponse
 */
export interface GetLeaguesResponse {
    /**
     * 
     * @type {Array<LeagueResponse>}
     * @memberof GetLeaguesResponse
     */
    leagues: Array<LeagueResponse>;
    /**
     * 
     * @type {Pagination}
     * @memberof GetLeaguesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the GetLeaguesResponse interface.
 */
export function instanceOfGetLeaguesResponse(value: object): value is GetLeaguesResponse {
    if (!('leagues' in value) || value['leagues'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function GetLeaguesResponseFromJSON(json: any): GetLeaguesResponse {
    return GetLeaguesResponseFromJSONTyped(json, false);
}

export function GetLeaguesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeaguesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'leagues': ((json['leagues'] as Array<any>).map(LeagueResponseFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

export function GetLeaguesResponseToJSON(json: any): GetLeaguesResponse {
    return GetLeaguesResponseToJSONTyped(json, false);
}

export function GetLeaguesResponseToJSONTyped(value?: GetLeaguesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leagues': ((value['leagues'] as Array<any>).map(LeagueResponseToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

